/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyUserDto } from '../models/CompanyUserDto';
import type { CreateCompanyUserDto } from '../models/CreateCompanyUserDto';
import type { UpdateCompanyUserDto } from '../models/UpdateCompanyUserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyUsersService {

  /**
   * @returns CompanyUserDto OK
   * @throws ApiError
   */
  public static listCompanyUsers({
    companyKey,
    isActive,
  }: {
    companyKey: string,
    isActive?: boolean,
  }): CancelablePromise<Array<CompanyUserDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/companies/{companyKey}/users',
      path: {
        'companyKey': companyKey,
      },
      query: {
        'isActive': isActive,
      },
    });
  }

  /**
   * @returns CompanyUserDto OK
   * @throws ApiError
   */
  public static createCompanyUsers({
    companyKey,
    requestBody,
  }: {
    companyKey: string,
    requestBody?: CreateCompanyUserDto,
  }): CancelablePromise<CompanyUserDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/companies/{companyKey}/users',
      path: {
        'companyKey': companyKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static updateCompanyUser({
    companyKey,
    userId,
    requestBody,
  }: {
    companyKey: string,
    userId: string,
    requestBody?: UpdateCompanyUserDto,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/companies/{companyKey}/users/{userId}',
      path: {
        'companyKey': companyKey,
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCompanyUser({
    companyKey,
    userId,
  }: {
    companyKey: string,
    userId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/companies/{companyKey}/users/{userId}',
      path: {
        'companyKey': companyKey,
        'userId': userId,
      },
    });
  }

}
